<template>
  <div class="home" v-scroll="onScroll">
    <div
      style="position:absolute; top:0px; height:40vh; width:100%; background-image: url(/img/backgrounds/pcb.jpg);background-size:cover">
    </div>
    <v-row style="min-height:40vh">
      <v-col cols="12" :xs="12" class="fadeInUp">


        <!--div id="bgbirds" ></div-->
        <KinesisContainer v-show="scroll < 200" class="fadeInUp" style="position:absolute;top:10vh;left:5%;width:95%">
          <KinesisElement tag="img" src="/img/logo-white-blue2.png" :strength="-5" type="depth" axis="x"
            class="main-logo" />
        </KinesisContainer>



      </v-col>
    </v-row>

    <v-row style="min-height:60vh">
      <v-col cols="12" :xs="12" class="fadeInUp">
        <div class="about-items">
          <v-row>
            <v-col cols="12" :xs="12" :sm="12" :md="0" :lg="2" :xl="2"></v-col>
            <v-col cols="10" :xs="9" :sm="8" :md="5" :lg="4" :xl="3">
              <v-list shaped style="background-color:transparent">
                <v-list-item-group v-model="selectedItem" color="primary" @change="itemChanged()">
                  <v-list-item class="animate__animated animate__fadeInUp" light
                    :style="'animation-delay:' + (1 + (i / 2)) + 's'" v-for="(item, i) in items" :key="i">
                    <v-list-item-icon>
                      <v-icon v-text="item.icon"></v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title v-text="item.text" class="list-item-text"></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-col>
            <v-col cols="10" :xs="9" :sm="8" :md="4" :lg="3" :xl="3">

              <v-card light elevation="0" class="animate__animated animate__fadeInUp"
                :style="'background-color:transparent'" v-if="selectedItem >= 0">
                <v-card-text>
                  <h4 class="home-description-text">{{ items[selectedItem].detail }}</h4>
                </v-card-text>
              </v-card>



            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>







    <!--Transition id="whyus" class="fadeInUp" direction="white-black"/>

    <v-row class="w3-animate-opacity" style="background-color:black;padding-top:64px;margin-left:0px;margin-right:0px">
      <v-col cols="1"></v-col>
      <v-col cols="5" align="start" >
        <v-img
          src="/img/products/iot_qr_scanner_01.png"
        >
        </v-img>
      </v-col>
      <v-col cols="5" >
        <h2>CamScan</h2>
        <h3>LIOT-CAMSCAN-01</h3>
        <p>A multi purpose QR/Barcode scanner that is IOT enabled on the loomIOT.net IOT wide access network</p>
        <p>Whats is unique about this scanner is that it can synchronise data with the cloud and operate completely offline.</p>
        <p> Perfect for those mission critical scenarios like access control where reliance on connectivity to a central datastore is problematic for continous operation.</p>
        <p>Paired with LoRa hub the the scanner can be configured remotely through loomIOT.net dashboard and has a host of configrable parameters such as:</p>
        <ul>
          <li>
            Wifi Settings
          </li>  
          <li>
            Data Synchronisation Settings
          </li>  
          <li>
            Logging
          </li>  
          <li>
            Customisable states
          </li>
          <li>
            Customisable graphics
          </li>
        </ul>  
      </v-col>
      <v-col cols="1"></v-col>
    </v-row>

    <Transition id="focusAreas" class="fadeInUp"/>

    
    <ProtocolOne  class="fadeInUp"/-->

  </div>
</template>

<script>

//import Transition from '../Transition'
//import ProtocolOne from '../components/ProtocolOne'
import { KinesisContainer, KinesisElement } from 'vue-kinesis'

export default {
  name: 'Home',
  components: {
    //Transition,
    //ProtocolOne,
    KinesisContainer,
    KinesisElement
  },
  data: () => ({
    selectedItem: -1,
    items: [
      { text: 'crafting experiences', icon: 'mdi-brush', detail: "Specialising in crafting experiences that delight end users while having the expertise to integrate into a wide range of systems. We are experts at integrating disparate systems into remarkable solutions" },
      { text: 'integrating skillfully', icon: 'mdi-code-braces', detail: "Integration is key to a seamless experience. loomitech is the research & development division of loomiToy (Pty) Ltd established in 2016, focussing on embedded systems, software development and systems integration for the small to medium enterprise." },
      { text: 'quality, fast', icon: 'mdi-clock', detail: "As a strong supporter of open source software we have expertise in an effective set of tools, frameworks and services to rapidly deliver quality solutions." },
      { text: 'cloud first', icon: 'mdi-cloud-check-outline', detail: "Tech changes too fast to worry about nuts and bolts. We cherry pick cloud technologies to get things up and running fast without the headaches of infrastructure" },
    ],
    scroll: 0,
    options: {
      mouseControls: true,
      touchControls: true,
      gyroControls: false,
      minHeight: 800.00,
      minWidth: 200.00,
      scale: 1.00,
      scaleMobile: 1.00,
      backgroundColor: 0xffffff,
      color: 0xafcfff
    }
  }),


  methods: {

    onScroll(args) {
      this.scroll = args.target.scrollingElement.scrollTop;
      //this.$refs.logo.$el.style.opacity = (300 - args.target.scrollingElement.scrollTop) / 300.0;
    },
    isMobile() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    itemChanged() {
      console.log('change', this.selectedItem);
      let temp = this.selectedItem;
      this.selectedItem = -1;
      setTimeout(() => {
        this.selectedItem = temp;
      }, 100);
    }
  },
  mounted() {
    console.log('mounted');
    /*window.VANTA.BIRDS({
      el: "#bgbirds",
      mouseControls: true,
      touchControls: true,
      gyroControls: false,
      minHeight: window.innerHeight,
      minWidth: 200.00,
      scale: 1.00,
      scaleMobile: 1.00,
      backgroundColor: 0xffffff,
      color1: 0xF06292,
      color2: 0xEC407A,
      backgroundAlpha: 0.00,
      quantity: 4
    });*/

    setTimeout(() => {
      this.selectedItem = 0;
    }, 3000);
  }
}
</script>

<style scoped>
.home {
  background: white;

}

.main-logo {}

.logo {
  font-size: 220px;
  width: 100%;
  padding-bottom: 0px;
  line-height: 220px;
  overflow: hidden;
  text-align: center;
}

.logo-block {
  padding-top: 15%;
  margin: auto;
  position: relative;
  overflow: hidden;
  width: 100%;
}

.sub-text {
  padding-right: 0px;
  text-align: right;
  overflow: hidden;
  padding-right: 20%;
}

.about-items {
  margin-top: 5%;
}

.home-description-text {
  font-size: 24px;
  text-align: left
}

.list-item-text {
  font-size: 32px;
  text-align: left
}


@media (max-width: 1220px) {
  .about-items {
    margin-top: 0%;
  }

  .list-item-text {
    font-size: 26px;
    text-align: left
  }

  .home-description-text {
    font-size: 22px;
    text-align: left
  }
}

@media (max-width: 1020px) {
  .about-items {
    margin-top: 0%;
  }

  .list-item-text {
    font-size: 28px;
    text-align: left
  }

  .home-description-text {
    font-size: 24px;
    text-align: left
  }
}

@media (max-width: 600px) {
  .about-items {
    margin-top: -32px;
  }

  .list-item-text {
    font-size: 22px;
    text-align: left
  }

  .home-description-text {
    font-size: 20px;
    margin-top: -32px;
    text-align: left
  }
}

.watermark-black {
    font-size: 256px;
    font-family: "Walkway Black";
    font-weight: lighter;
    line-height: 280px;
    margin-top: 32px;
    color: rgba(255, 255, 255, 0.05);
    max-width: 100%;
    overflow: hidden;
}

.header-watermark {
    font-size: 256px;
    font-family: "Walkway Black";
    font-weight: lighter;
    line-height: 280px;
    overflow: hidden;
    color: rgba(0, 0, 0, 0.05);
    margin-bottom: -100px;
    margin-top: 32px;
}

.carousel-view {
    height: 80vh;
    width: 80vw;
    border-radius: 5px;
    z-index: 100;
}

.close-button {

    background-color: white;
}

.portfolio-list {
    margin-top: 32px;
}

.portfolio-item {
    position: relative;
    margin-top: 120px;
    min-height: 50vh;
    cursor: pointer;
}

.web-section {
    position: relative;
    background-color: #111111;
    min-height: 100vh;
    width: auto;
    background: url('/img/bg2.jpg');
    background-size: cover
}

.web-heading {
    position: absolute;
    width: 100%;
    top: 0%
}

@media (max-width: 1020px) {
    .portfolio-item {
        position: relative;
        margin-top: 120px;
        min-height: 40vh;
        cursor: pointer;
    }
}

@media (max-width: 600px) {
    .portfolio-item {
        position: relative;
        margin-top: 32px;
        min-height: 25vh;
        cursor: pointer;
    }
}

@media (max-width: 1020px) {
    .portfolio-item {
        position: relative;
        margin-top: 120px;
        min-height: 40vh;
        cursor: pointer;
    }

    .header-watermark {
        font-size: 200px;
        font-family: "Walkway Black";
        font-weight: lighter;
        line-height: 280px;
        overflow: hidden;
        color: rgba(0, 0, 0, 0.05);
        margin-bottom: -100px;
        margin-top: 0px;
    }

    h3 {
        font-family: "Walkway Black", Helvetica, Arial;
        font-size: 32px;
        font-weight: lighter;
        line-height: 40px;
    }

    h4 {

        font-size: 20px;
        font-weight: lighter;
        line-height: 28px;
        margin-top: 8px;
        margin-bottom: 16px;
    }
}

@media (max-width: 600px) {
    .portfolio-item {
        position: relative;
        margin-top: 32px;
        min-height: 25vh;
        cursor: pointer;
    }

    .header-watermark {
        font-size: 128px;
        font-family: "Walkway Black";
        font-weight: lighter;
        line-height: 280px;
        overflow: hidden;
        color: rgba(0, 0, 0, 0.05);
        margin-bottom: -100px;
        margin-top: 0px;
    }

    h3 {
        font-family: "Walkway Black", Helvetica, Arial;
        font-size: 32px;
        font-weight: lighter;
        line-height: 40px;
    }

    h4 {

        font-size: 20px;
        font-weight: lighter;
        line-height: 28px;
        margin-top: 8px;
        margin-bottom: 16px;
    }
}

.row {
  width:100%!important;
}
</style>
